<template>
  <transition name="message-fade">
    <div v-if="visible" :class="['message', type]">
      {{ text }}
    </div>
  </transition>
</template>

<script>
export default {
  name: 'Message',
  data() {
    return {
      visible: false,
      text: '',
      type: 'info',
      duration: 3000
    }
  },
  methods: {
    show(text, type = 'info', duration = 3000) {
      this.text = text
      this.type = type
      this.duration = duration
      this.visible = true
      setTimeout(() => {
        this.visible = false
      }, this.duration)
    }
  }
}
</script>

<style scoped>
.message {
  position: fixed;
  top: 20px;
  left: 50%;
  transform: translateX(-50%);
  padding: 10px 20px;
  border-radius: 4px;
  color: white;
  font-size: 14px;
  z-index: 9999;
}

.success {
  background-color: #67c23a;
}

.warning {
  background-color: #e6a23c;
}

.error {
  background-color: #f56c6c;
}

.info {
  background-color: #909399;
}

.message-fade-enter-active,
.message-fade-leave-active {
  transition: opacity 0.3s, transform 0.3s;
}

.message-fade-enter,
.message-fade-leave-to {
  opacity: 0;
  transform: translate(-50%, -20px);
}
</style>